import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
const getFileInfo = (fileName) => {
    const match = fileName.match(/\.(xlsx|csv|txt)$/i);
    return {
        ext: match ? match[1].toLowerCase() : "xlsx",
        baseName: fileName.replace(/\.(xlsx|csv|txt)$/i, ""),
    };
};
export const downloadFile = ({ countryCode, fileName, config }) => {
    if (!fileName || !countryCode || !config)
        return;
    const { ext, baseName } = getFileInfo(fileName);
    const { columns, rows, withHeader } = config;
    // Fallback logic
    const selectedColumns = columns || (columns === null || columns === void 0 ? void 0 : columns.default) || [];
    const selectedRows = (rows === null || rows === void 0 ? void 0 : rows[countryCode]) || (rows === null || rows === void 0 ? void 0 : rows.default) || [];
    if (!selectedColumns.length) {
        console.warn("No columns found, file will be empty");
    }
    // 🔹 Generate phone dynamically if column exists
    const processedRows = selectedRows.map((row, index) => {
        if (selectedColumns.some((c) => c.key === "phone")) {
            return Object.assign(Object.assign({}, row), { phone: `${countryCode}${1000000000 + index}` });
        }
        if (selectedColumns.some((c) => c.key === "countryCode")) {
            return Object.assign(Object.assign({}, row), { countryCode: `${countryCode}` });
        }
        return row;
    });
    /* =========================
       TXT ONLY (comma separated, no header)
       ========================= */
    if (ext === "txt") {
        const txtContent = processedRows
            .map((row) => selectedColumns.map((col) => { var _a; return (_a = row[col.key]) !== null && _a !== void 0 ? _a : ""; }).join(",") // 👈 comma separated
        )
            .join("\n"); // 👈 new line per row
        saveAs(new Blob([txtContent], { type: "text/plain;charset=utf-8;" }), `${baseName}.txt`);
        return;
    }
    /* =========================
       EXISTING CSV / XLSX LOGIC
       ========================= */
    let worksheet;
    if (withHeader) {
        const data = processedRows.map((row) => selectedColumns.reduce((acc, col) => {
            var _a;
            acc[col.label] = (_a = row[col.key]) !== null && _a !== void 0 ? _a : "";
            return acc;
        }, {}));
        worksheet = XLSX.utils.json_to_sheet(data);
    }
    else {
        const aoaData = processedRows.map((row) => selectedColumns.map((col) => { var _a; return (_a = row[col.key]) !== null && _a !== void 0 ? _a : ""; }));
        worksheet = XLSX.utils.aoa_to_sheet(aoaData);
    }
    // 🔹 CSV (unchanged)
    if (ext === "csv") {
        const csv = XLSX.utils.sheet_to_csv(worksheet);
        saveAs(new Blob([csv], { type: "text/csv;charset=utf-8;" }), `${baseName}.csv`);
        return;
    }
    // 🔹 XLSX (unchanged)
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sample");
    const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
    });
    saveAs(new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }), `${baseName}.xlsx`);
};
export const downloadFileWithout_txt = ({ countryCode, fileName, config }) => {
    if (!fileName || !countryCode || !config)
        return;
    const { ext, baseName } = getFileInfo(fileName);
    const { columns, rows, withHeader } = config;
    //  Fallback logic for BOTH columns & rows
    const selectedColumns = columns || (columns === null || columns === void 0 ? void 0 : columns.default) || [];
    const selectedRows = (rows === null || rows === void 0 ? void 0 : rows[countryCode]) || (rows === null || rows === void 0 ? void 0 : rows.default) || [];
    if (!selectedColumns.length) {
        console.warn("No columns found, file will be empty");
    }
    // 🔹 Generate phone dynamically if column exists
    const processedRows = selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.map((row, index) => {
        if (selectedColumns === null || selectedColumns === void 0 ? void 0 : selectedColumns.some((c) => c.key === "phone")) {
            return Object.assign(Object.assign({}, row), { phone: `${countryCode}${1000000000 + index}` });
        }
        return row;
    });
    let worksheet;
    if (withHeader) {
        //  HEADER MODE
        const data = processedRows.map((row) => selectedColumns.reduce((acc, col) => {
            var _a;
            acc[col.label] = (_a = row[col.key]) !== null && _a !== void 0 ? _a : "";
            return acc;
        }, {}));
        worksheet = XLSX.utils.json_to_sheet(data);
    }
    else {
        //  NO HEADER MODE
        const aoaData = processedRows.map((row) => selectedColumns.map((col) => { var _a; return (_a = row[col.key]) !== null && _a !== void 0 ? _a : ""; }));
        worksheet = XLSX.utils.aoa_to_sheet(aoaData);
    }
    // 🔹 CSV
    if (ext === "csv") {
        const csv = XLSX.utils.sheet_to_csv(worksheet);
        saveAs(new Blob([csv], { type: "text/csv;charset=utf-8;" }), `${baseName}.csv`);
        return;
    }
    // 🔹 XLSX
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sample");
    const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
    });
    saveAs(new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }), `${baseName}.xlsx`);
};
